import React from 'react'
import moment from 'moment'
import { COLORES } from '../../../../../../config/colores'

export const COLUMNS_ACTIVIDAD_BARRERA = [
  {
    name: 'fechaDeReferencia',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => fecha ? <>{moment(fecha).format('DD-MM-YYYY HH:mm')}</> : null,
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'balancero',
    label: 'Balancero',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'motivoActividad',
    label: 'Motivo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'ultimoPesoDeEquilibrio',
    label: 'Último peso',
    options: {
      filter: false,
      sort: true
    }
  }
]
